import { gql } from '@apollo/client';

const SupplierMarketingUpdate = gql`
  mutation supplierMarketingUpdate(
    $minimisedSupplierId: String
    $customerNumber: String
    $customerEmail: String
    $supplierId: UUID
  ) {
    supplierMarketingUpdate(
      minimisedSupplierId: $minimisedSupplierId
      customerNumber: $customerNumber
      customerEmail: $customerEmail
      supplierId: $supplierId
    ) {
      success
    }
  }
`;

export default SupplierMarketingUpdate;
